const httpStatusList = {
  200: '200 OK',
  201: '201 Created',
  403: '403 Forbidden',
  404: '404 Not Found',
  400: '400 Bad Request',
  500: '500 Internal Error'
};

export class httpStatus {
  static get OK() {
    return 200;
  }

  static get Created() {
    return 201;
  }

  static get BadRequest() {
    return 400;
  }

  static get Forbidden() {
    return 403;
  }

  static get NotFound() {
    return 404;
  }

  static get InternalError() {
    return 500;
  }

  static get codes() {
    return Object.keys(httpStatusList);
  }

  static getText(code) {
    const codeIndex = Object.keys(httpStatusList).findIndex((statusCode) =>
      Number(statusCode) === code);
    return codeIndex > -1 ? Object.values(httpStatusList)[codeIndex] : undefined;
  }

  static has(code) {
    return !!httpStatus.getText(code);
  }
}
